import { useCallback, useEffect, useMemo, useState } from "react";
import { debounce } from "lodash-es";

export const useSearchLogic = (debounceDelay: number = 300) => {
    const [searchValue, setSearchValue] = useState("");
    const [deferredSearchValue, setDeferredSearchValue] = useState("");
    const [isSearching, setIsSearching] = useState(false);

    const debouncedSearch = useMemo(
        () =>
            debounce((value: string) => {
                setDeferredSearchValue(value);
                setIsSearching(false);
            }, debounceDelay),
        [debounceDelay],
    );

    const handleSearchChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            const value = e.target.value;
            setSearchValue(value);
            setIsSearching(value.trim() !== "");
            debouncedSearch(value);
        },
        [debouncedSearch],
    );

    const clearSearch = useCallback(() => {
        setSearchValue("");
        setDeferredSearchValue("");
        setIsSearching(false);
        debouncedSearch.cancel();
    }, [debouncedSearch]);

    useEffect(() => {
        return () => {
            debouncedSearch.cancel();
        };
    }, [debouncedSearch]);

    return {
        searchValue,
        deferredSearchValue,
        isSearching,
        handleSearchChange,
        clearSearch,
        setSearchValue,
    };
};
